import moment from 'moment';

export default function genererCritereRechercheReseauLc() {
  return {
    fromDate: moment(new Date()).startOf('day').toDate(),
    toDate: (moment(new Date())).endOf('day').add(12, 'months').toDate(),
    libelle: null,
    villes: [],
    formats: [],
    reference: null,
    inclureConfreres: false,
    societeId: null,
    agencesId: [],
  };
}
